import "vant/es/toast/style";
import _Toast from "vant/es/toast";
import _objectSpread from "/home/jenkins/workspace/AI\u5408\u89C4\u524D\u7AEF-\u6D4B\u8BD5/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import history from './history.vue';
import Chat from './chat/index.vue';
import { mapGetters } from 'vuex';
import { getToken, removeSessionStorage } from '@/utils/storage';
import SvgIcon from '@/components/svg-icon.vue';
export default {
  components: {
    SvgIcon: SvgIcon,
    history: history,
    Chat: Chat
  },
  data: function data() {
    return {
      hasBizToken: false
    };
  },
  computed: _objectSpread({}, mapGetters('ai', ['aiLoading'])),
  beforeDestroy: function beforeDestroy() {
    removeSessionStorage('windowId');
    removeSessionStorage('conversationId');
    this.$store.dispatch('ai/reset');
  },
  mounted: function mounted() {
    this.hasBizToken = !!getToken(); // 判断是否有业务token,注意：是业务token，不是AI token
  },
  methods: {
    handleNewChat: function handleNewChat() {
      if (this.aiLoading) {
        return _Toast({
          message: '请先停止回答!'
        });
      }
      this.$eventBus.$emit('new-conversation');
    }
  }
};